

    /**
     * Checks if the value is created by the `Object` constructor.
     */
    function isPlainObject(value) {
        return (!!value && typeof value === 'object' &&
            value.constructor === Object);
    }

    module.exports = isPlainObject;





/*****************
 ** WEBPACK FOOTER
 ** ./~/mout/lang/isPlainObject.js
 ** module id = 13
 ** module chunks = 0
 **/